export const types = Object.freeze({
    RESET_TRIP_TRACER: 'tripTracer/RESET',
    AGENCY_REQUEST: 'tripTracer/AGENCY_REQUEST',
    AGENCY_SUCCESS: 'tripTracer/AGENCY_SUCCESS',
    AGENCY_ERROR: 'tripTracer/AGENCY_ERROR',
    AVL_DATES_REQUEST: 'tripTracer/AVL_DATES_REQUEST',
    AVL_DATES_SUCCESS: 'tripTracer/AVL_DATES_SUCCESS',
    AVL_DATES_ERROR: 'tripTracer/AVL_DATES_ERROR',
    VEHICLES_REQUEST: 'tripTracer/VEHICLES_REQUEST',
    VEHICLES_SUCCESS: 'tripTracer/VEHICLES_SUCCESS',
    VEHICLES_ERROR: 'tripTracer/VEHICLES_ERROR',
    ROUTES_REQUEST: 'tripTracer/ROUTES_REQUEST',
    ROUTES_SUCCESS: 'tripTracer/ROUTES_SUCCESS',
    ROUTES_ERROR: 'tripTracer/ROUTES_ERROR',
    SET_QUERY_MODE: 'tripTracer/SET_QUERY_MODE',
    ROUTE_SHAPE_REQUEST: 'tripTracer/ROUTE_SHAPE_REQUEST',
    ROUTE_SHAPE_SUCCESS: 'tripTracer/ROUTE_SHAPE_SUCCESS',
    ROUTE_SHAPE_ERROR: 'tripTracer/ROUTE_SHAPE_ERROR',
    STOPS_REQUEST: 'tripTracer/STOPS_REQUEST',
    STOPS_SUCCESS: 'tripTracer/STOPS_SUCCESS',
    STOPS_ERROR: 'tripTracer/STOPS_ERROR',
    SELECT_ROUTE: 'tripTracer/SELECT_ROUTE',
    SELECT_VEHICLE: 'tripTracer/SELECT_VEHICLE',
    SET_TIME_WINDOW: 'tripTracer/SET_TIME_WINDOW',
    CLEAR_SERVICE_DATE: 'tripTracer/CLEAR_SERVICE_DATE',
    REPLAY_REQUEST: 'tripTracer/REPLAY_REQUEST',
    REPLAY_SUCCESS: 'tripTracer/REPLAY_SUCCESS',
    REPLAY_ERROR: 'tripTracer/REPLAY_ERROR',
    REPLAY_CANCELED: 'tripTracer/REPLAY_CANCELED',
    SET_PLAYBACK_STATUS: 'tripTracer/SET_PLAYBACK_STATUS',
    SET_PLAYHEAD: 'tripTracer/SET_PLAYHEAD',
    SET_PLAYBACK_SPEED: 'tripTracer/SET_PLAYBACK_SPEED',
    FOCUS_POINT: 'tripTracer/FOCUS_POINT',
    SET_DISPLAY_OPTION: 'tripTracer/SET_DISPLAY_OPTION',
    SET_HIDDEN_VEHICLES: 'tripTracer/SET_HIDDEN_VEHICLES',
});
